/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { IBvMenuItem } from 'volta/components/bv-menu';

import templateOnlyComponent from '@ember/component/template-only';

export interface BvMenuItemSignature {
  Args: {
    item: IBvMenuItem;
    onClick: (event: Event) => void;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLLIElement;
}

const BvMenuItemComponent = templateOnlyComponent<BvMenuItemSignature>();

export default BvMenuItemComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvMenu::Item': typeof BvMenuItemComponent;
    'bv-menu/item': typeof BvMenuItemComponent;
  }
}
